import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.274 5.138a1.8 1.8 0 0 1 2.502-.243l1.39 1.08a1.72 1.72 0 0 1 .578 2.396c-.027.043-7.654 9.584-7.654 9.584a1.36 1.36 0 0 1-1.051.508l-2.921.037-.658-2.786c-.092-.391 0-.803.254-1.12z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m14.863 6.909 4.376 3.36"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M4.33 7.5s2.183.853 3 2c2.026 2.845-6.026 5.155-4 8 .817 1.147 3 2 3 2"
    }, null, -1)
  ]))]))
}
export default { render: render }